<template>
    <div class="dashboard-users-view">
        <div class="dashboard-users-view__filters">
            <BaseInput
                :debounce="400"
                :placeholder="$t('searchPlaceholder')"
                block
                trim
                @input="nameSearchQuery = $event"
            >
                <template #icon>
                    <SearchIcon width="16" height="16" />
                </template>
            </BaseInput>

            <BaseButton block @click="openCreateModal">
                <template #icon>
                    <AddIcon width="16" height="16" />
                </template>

                {{ $t('create') }}
            </BaseButton>
        </div>

        <div class="dashboard-users-view__content">
            <UsersTable ref="usersTable" :filter-name="nameSearchQuery" />
        </div>
    </div>
</template>

<script>
import AddIcon from '../icons/AddIcon'
import BaseButton from '../redesigned/BaseButton'
import BaseInput from '../redesigned/BaseInput'
import SearchIcon from '../icons/SearchIcon'
import UserEditModal from '../redesigned/UserEditModal'
import UsersTable from '../UsersTable'

export default {
    name: 'DashboardUsersView',
    components: {
        AddIcon,
        BaseButton,
        BaseInput,
        SearchIcon,
        UsersTable,
    },
    data() {
        return {
            nameSearchQuery: '',
        }
    },
    methods: {
        openCreateModal() {
            this.$modal.show(
                UserEditModal,
                { onSubmit: this.$refs.usersTable.fetchUsers },
                { width: 400, height: '75%' }
            )
        },
    },
}
</script>

<i18n>
{
    "en": {
        "create": "Create user",
        "searchPlaceholder": "Name"
    },
    "de": {
        "create": "Neuer Benutzer",
        "searchPlaceholder": "Name"
    },
    "fr": {
        "create": "Nouvel utilisateur",
        "searchPlaceholder": "Nom"
    },
    "it": {
        "create": "Nuovo utente",
        "searchPlaceholder": "Nome"
    }
}
</i18n>

<style lang="scss" scoped>
.dashboard-users-view {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    &__filters {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 1.5rem 1rem 0.5rem 2rem;
        background-color: $color-gray-lighter-new;
        border-bottom: $style-border;

        & > * {
            margin-right: 1rem;
            margin-bottom: 1rem;
        }

        .base-input,
        .multiselect {
            max-width: 200px;
        }
    }

    &__content {
        display: flex;
        overflow-y: auto;

        & > * {
            width: 100%;
            overflow-x: auto;
        }
    }

    @include respond-to('for-small-mobile-only') {
        &__filters {
            padding: 1rem 1rem 0;

            & > * {
                &:not(.base-button) {
                    margin-right: 0;
                    max-width: 100%;
                    width: 100%;
                }
            }
        }
    }
}
</style>
